import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=125c0929&"
import script from "./Iframe.vue?vue&type=script&lang=ts&"
export * from "./Iframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports